export default __webpack_public_path__ + "static/media/mainimage.a4912861.png";